import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Conta from "model/administracao/cadastro/Conta";
import Modulo from "model/administracao/cadastro/Modulo";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FileUpload, FileUploadHandlerEvent } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import ContaService from "service/administracao/cadastro/ContaService";

const contaService = new ContaService();

export default function ContaCadastro() {

    const navigate = useNavigate();

    const [conta, setConta] = useState<Conta>(new Conta());
    const [modulos, setModulos] = useState<Modulo[]>([]);
    const [zones, setZones] = useState<string[]>([]);

    const logoUploadRef = useRef<FileUpload>(null);
    const [logo, setLogo] = useState<any>();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const { control, setError, formState: { errors }, register, clearErrors } = useForm();

    useEffect(() => {

        contaService.modulos().then(modulosParam => {
            setModulos(modulosParam);
        });
        contaService.zones().then(zonesParam => {
            setZones(zonesParam);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    useEffect(() => {
        if (conta.id) {
            contaService.buscarLogo(conta.id).then(logoParam => {
                setLogo(blobToFile(logoParam, "logo.png"));
            }).catch(err => {
                console.log(err);
            });
        }
    }, [conta.id]);

    function blobToFile(blob: any, fileName: string) {
        const file: any = new File([blob], fileName, { type: blob.type });
        file.objectURL = URL.createObjectURL(blob);
        return file;
    }

    function validar() {

        if (!conta.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!conta.timezone) {
            setError("timezone", { type: "manual", message: "Fuso-horário é obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    function acessarListaUsuarios() {
        navigate(`/usuarios?idConta=${conta.id}`);
    }

    function acessarListaPerfis() {
        navigate(`/perfis?idConta=${conta.id}`);
    }

    function botoesExtra() {
        return <>
            <Button type="button" label="Perfis" style={{ marginLeft: 8 }} className="ui-button-info" onClick={() => acessarListaPerfis()}></Button>
            <Button type="button" label="Usuários" style={{ marginLeft: 8 }} className="ui-button-info" onClick={() => acessarListaUsuarios()}></Button>
        </>;
    }

    function onUploadImagemLogo(e: FileUploadHandlerEvent) {
        setLogo(e.files[0]);
        contaService.gravarLogo(conta.id, e.files[0]).then(() => {
            msgSucesso('Sucesso', 'Logo gravado com sucesso');
        }).catch(err => {
            console.log(err);
            msgErro('Erro', 'Erro ao gravar logo');
        });
        logoUploadRef.current?.clear();
    }

    return (

        <BaseCadastro model={conta} service={contaService} setModel={(value: Conta) => setConta(value)} validar={() => validar()} urlService="/conta" pathCadastro="/conta" tituloPagina={'Conta'} botoesExtra={botoesExtra()}>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={conta.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setConta({ ...conta, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <div className="col-sm-12">

                    <DataTable
                        emptyMessage="Nenhum registro encontrado"
                        header='Módulos'
                        value={modulos}
                        selectionMode='checkbox'
                        selection={conta.modulos}
                        onSelectionChange={(e: any) => setConta({ ...conta, modulos: e.value as Modulo[] })}
                        dataKey="id"
                        tableStyle={{ minWidth: '50rem' }}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column field="nome" header="Nome"></Column>
                    </DataTable>

                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Fuso-horário</Label>
                <div className="col-sm-12">
                    <Controller name="documentos" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            filter
                            options={zones}
                            className={errors.timezone ? "p-invalid" : ""}
                            value={conta.timezone}
                            onChange={(e) => {
                                setConta({ ...conta, timezone: e.value })
                                clearErrors("timezone")
                            }}
                            style={{ width: '100%' }}
                        />
                    )} />
                </div>
                {errors.timezone && errors.timezone.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.timezone?.message as string}</span> : null}
            </div>

            <div className="col-sm-12">

                <Panel header="Logo" toggleable={true} style={{ marginTop: 16, width: "20%" }}>

                    <div style={{ maxWidth: "100%", marginBottom: 20 }}>
                        {logo ?
                            <img src={logo.objectURL} alt="logo" width={"100%"} />
                            :
                            <p>Nenhuma Imagem cadastrada</p>}

                    </div>
                    <FileUpload mode="basic" name="arquivos" ref={logoUploadRef} customUpload={true} accept="image/*" maxFileSize={10000000} uploadHandler={onUploadImagemLogo} auto={true} chooseLabel="Escolher" />
                </Panel>
            </div>

        </BaseCadastro>
    )
}
